import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { AppBar, Toolbar, Typography, IconButton, Button, Tooltip } from 'material-ui';
import { bindActionCreators } from 'redux';
import * as mainActions from '../../actions/mainActions';
import { connect } from 'react-redux';
import ExitToApp from 'material-ui-icons/ExitToApp';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle } from 'material-ui/Dialog';
import logo from '../../resources/images/logo_arousa_norte.png';

class AppNavbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    setLogoutAlert = (open) => {
        this.setState({ open: open });
    }

    render() {
        const { classes } = this.props;
        const { buttonLogout, alertButton } = customStyles;
        const { sessionData: { name } } = this.props.main;
        return (
            <Fragment>
                <AppBar position="fixed" className={classes.appBar} style={{ height: '3em' }}>
                    <Toolbar style={{ marginTop: '-0.5em' }}>
                        <Typography variant="headline" className={classes.flex}>
                            <img width="250" style={{ marginTop: '0.4em' }} src={logo} alt="Arousanorte" />
                        </Typography>
                        <Typography variant="subheading" style={customStyles.labelName}>
                            {name}
                        </Typography>
                        <Tooltip id="tooltip-bottom-end" title="Pechar sesión" placement="bottom-end">
                            <IconButton style={buttonLogout} onClick={() => { this.setLogoutAlert(true) }}>
                                <ExitToApp />
                            </IconButton>
                        </Tooltip>
                    </Toolbar>
                </AppBar>
                <Dialog open={this.state.open} onClose={() => { this.setLogoutAlert(false) }} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Cerrar sesión"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            ¿Seguro que quieres cerrar sesión?
            </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.setLogoutAlert(false) }} style={alertButton}>
                            No
            </Button>
                        <Button onClick={this.props.actions.logout} style={alertButton} autoFocus>
                            Si
            </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

const styles = theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "#222"
    },
    flex: {
        flex: 1
    }
});

const customStyles = {
    labelName: {
        marginRight: "2em",
        color: "white",
        fontSize: "1.3rem"
    },
    buttonLogout: {
        color: "#DDD",
    },
    alertButton: {
        color: "#2962FF"
    }
}

AppNavbar.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

const mapStateToProps = (state) => ({
    main: state.main
});

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(AppNavbar));



// WEBPACK FOOTER //
// ./src/components/displayComponents/AppNavbar.js